<template>
    <div class="goods-list" v-if="((finalDatas.items && finalDatas.items.length > 0) || showAll == 'T') && canRequest"
        :style="componentBgColor">
        <div class="goods-list-header"
            v-if="finalDatas.items && (finalDatas.goodstitle != '' || finalDatas.isShowMore) && showAll != 'T'">
            <h1 class="goods-list-title" :style="titFontSize">{{ finalDatas.goodstitle }}</h1>
            <div class="more" @click="goGoodsList" v-if="finalDatas.isShowMore">更多<i class="iconfont icongengduo1"></i>
            </div>
        </div>
        <waterfall col="2" :data="finalDatas.items" :width="itemWidth"
            v-if="finalDatas.layout == 'grid' && closeWaterfall != 'T' && waterFall" class="goods-list-box waterfall">

            <div class="box" v-for="(item, i) in finalDatas.items" :key="i" @click="goGoods(item)"
                v-if="i < finalDatas.maxnum || showAll == 'T'" :style="goodsStyle">
                <div class="img-box">
                    <img class="img" :src="item.logo + '?imageMogr2/thumbnail/334x'" :style="imgStyle" />
                    <div class="label" v-if="finalDatas.isShowTag && item.goodsattr && item.goodsattr != ''"
                        :style="labColor">
                        {{ item.goodsattr }}
                        <div class="labelBg" :style="labBg"></div>
                    </div>
                    <div class="hotelName"
                        v-if="item.supplierName && item.supplierName != '' && showListHotelName != 'F'">
                        <b>{{ item.supplierName }}</b>
                    </div>
                    <div class="hotelName"
                        v-else-if="item.hotelName && item.hotelName != '' && showListHotelName != 'F'">
                        <b>{{ item.hotelName }}</b>
                    </div>
                </div>
                <div class="goods-content">
                    <div class="goods-name">{{ item.name }}</div>
                    <div class="goods-desc" v-if="item.secondTitle">{{ item.secondTitle }}</div>
                    <div class="goods-desc" v-else></div>
                    <div class="goods-discount" v-if="item.extraInfo && item.extraInfo.discountList">
                        <div class="goods-discount-item" v-if="item.extraInfo.discountList.length > 0"
                            v-for="(discount, j) in item.extraInfo.discountList" :key="j">
                            <span>{{ discount.discountTxt }}</span>
                        </div>
                    </div>
                    <div class="price-box" :style="priceColor">
                        <div class="price" v-if="item.openType == 'apply'">
                            <span class="cur-price">
                                <b :style="priceSize">免费开通</b>
                            </span>
                        </div>
                        <div class="price" v-else-if="item.directlyBuy == 'F'">
                            <span class="cur-price">
                                <b :style="priceSize">价格面议</b>
                            </span>
                        </div>
                        <div class="price"  v-else-if="item.price==-1&&item.sourceType=='hotel'">
                            <span class="cur-price free">
                                <b :style="priceSize">满房</b>
                            </span>
                        </div>
                        <div class="price" v-else-if="!(item.price <= 0 && item.credit <= 0)">
                            <span class="cur-price" v-if="item.price > 0">
                                <i>￥</i>
                                <b :style="priceSize">{{ item.price }}</b>
                            </span>
                            <div class="credit" v-if="item.credit > 0">
                                <span>
                                    <em v-if="item.price > 0">
                                        <span v-if="item.sourceType == 'hotel'">+</span>
                                        <span v-else-if="priceOrCredit != 'T'">+</span>
                                        <span v-else-if="priceOrCredit == 'T'">/</span>
                                    </em>
                                    {{ item.credit }}
                                </span>
                                <b>{{ creditName }}</b>
                            </div>
                            <div class="qi"
                                v-if="item.sourceType == 'scenic' || item.sourceType == 'diy' || item.skuFlag == 'T'|| item.sourceType == 'hotel' ">
                                起</div>
                            <span class="proposedPrice" v-if="item.proposedPrice > 0">
                                ￥{{ item.proposedPrice }}
                            </span>
                        </div>
                        <div class="price" v-else-if="item.sourceType == 'scenic' || item.sourceType == 'diy'">
                            <span class="cur-price">
                                <i>￥</i>
                                <b :style="priceSize">{{ item.price }}</b>
                            </span>
                            <div class="qi">起</div>
                        </div>
                        <div class="price" v-else>
                            <span class="cur-price free">
                                <b :style="priceSize">免费</b>
                            </span>
                        </div>
                        <div class="add-shopCar" @click.stop="isShowSku(item)"
                            v-if="isCloseCart != 'T' && finalDatas.isCart && item.sourceType == 'mall' && ((item.goodsConfig && item.goodsConfig.isWechatProfitSharing != 'T') || isOpenProfitSharingShopCart == 'T')">
                            <i class="iconfont iconjia1"></i>
                        </div>
                    </div>
                </div>

                <div class="no-stock" v-if="item.stock != undefined && item.stock <= 0"><img
                        src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
            </div>

        </waterfall>
        <div class="goods-list-box" :class="finalDatas.layout" v-else>
            <div class="goods-list-container">
                <div class="box" v-for="(item, i) in finalDatas.items" :key="i" @click="goGoods(item)"
                    v-if="i < finalDatas.maxnum || showAll == 'T'" :style="goodsStyle">

                    <swiper-box v-if="finalDatas.layout == 'pic' && finalDatas.isLb"
                        :pics="item.pictureArr"></swiper-box>
                    <div class="img-box" :class="{ 'img-box-square': isSquarePic == 'T' }" v-else>
                        <img class="img" :src="item.logo + thumbSuffix" :style="imgStyle" />
                        <div class="label" v-if="finalDatas.isShowTag && item.goodsattr && item.goodsattr != ''"
                            :style="labColor">
                            {{ item.goodsattr }}
                            <div class="labelBg" :style="labBg"></div>
                        </div>
                        <div class="hotelName"
                            v-if="item.supplierName && item.supplierName != '' && showListHotelName != 'F'">
                            <b>{{ item.supplierName }}</b>
                        </div>
                        <div class="hotelName"
                            v-else-if="item.hotelName && item.hotelName != '' && showListHotelName != 'F'">
                            <b>{{ item.hotelName }}</b>
                        </div>
                    </div>
                    <div class="goods-content">
                        <div class="goods-name">{{ item.name }}</div>
                        <div class="goods-desc" v-if="item.secondTitle">{{ item.secondTitle }}</div>
                        <div class="goods-desc" v-else></div>
                        <div class="price-box" :style="priceColor">
                            <div class="price"  v-if="item.price==-1&&item.sourceType=='hotel'">
                                <span class="cur-price free">
                                    <b :style="priceSize">满房</b>
                                </span>
                            </div>
                            <div class="price" v-else-if="!(item.price <= 0 && item.credit <= 0)">
                                <span class="cur-price" v-if="item.price > 0">
                                    <i>￥</i>
                                    <b :style="priceSize">{{ item.price }}</b>
                                </span>
                                <div class="credit" v-if="item.credit > 0">
                                    <span>
                                        <em v-if="item.price > 0">
                                             <span v-if="item.sourceType == 'hotel'">+</span>
                                            <span v-else-if="priceOrCredit != 'T'">+</span>
                                            <span v-else-if="priceOrCredit == 'T'">/</span>
                                        </em>
                                        {{ item.credit }}
                                    </span>
                                    <b>{{ creditName }}</b>
                                </div>
                                <div class="qi"
                                    v-if="item.sourceType == 'scenic' || item.sourceType == 'diy' || item.skuFlag == 'T'|| item.sourceType == 'hotel'">
                                    起</div>
                                <span class="proposedPrice" v-if="item.proposedPrice > 0">
                                    ￥{{ item.proposedPrice }}
                                </span>
                            </div>
                            <div class="price" v-else-if="item.sourceType == 'scenic' || item.sourceType == 'diy'">
                                <span class="cur-price">
                                    <i>￥</i>
                                    <b :style="priceSize">{{ item.price }}</b>
                                </span>
                                <div class="qi">起</div>
                            </div>
                            <div class="price" v-else>
                                <span class="cur-price free">
                                    <b :style="priceSize">免费</b>
                                </span>
                            </div>
                            <div class="add-shopCar" @click.stop="isShowSku(item)"
                                v-if="isCloseCart != 'T' && finalDatas.isCart && item.sourceType == 'mall' && ((item.goodsConfig && item.goodsConfig.isWechatProfitSharing != 'T') || isOpenProfitSharingShopCart == 'T')">
                                <i class="iconfont iconjia1"></i>
                            </div>
                        </div>
                    </div>

                    <div class="no-stock" v-if="item.stock != undefined && item.stock <= 0"><img
                            src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                </div>
            </div>

        </div>
        <layerSku ref="layerSku" :goodsId="goodsId" :goodsDetail="goodsDetail" :curInfo="curInfo" showBtn=true>
        </layerSku>
    </div>
</template>

<script>
    // 商品
    import price from "@/components/price";
    import api from "@/utils/api";
    import {
        setStorage,
        getStorage
    } from "@/utils/wxuser";
    import {
        jAlert3,
        jAlert5
    } from '@/base/jAlert/jAlert';
    import moment from "moment";
    import layerSku from "@/components/layerSku.vue";
    import swiperBox from "@/components/swiperBox";
    var config = {};
    export default {
        name: "GoodsList",
        props: {
            datas: Object,
            showOther: {
                type: Boolean,
                default: () => true,
            },

            showTag: {
                type: Boolean,
                default: () => true,
            },
            showAll: {
                type: Boolean,
                default: () => 'F',
            },
            waterFall: {
                type: Boolean,
                default: () => true
            },
            templateId: String
        },
        data() {
            return {
                isSquarePic: getStorage('isSquarePic') || 'F',
                closeWaterfall: getStorage('closeWaterfall') || 'F',
                code: '',
                finalDatas: {},
                user: getStorage('user'),
                creditName: getStorage('creditName') || '积分',
                goodsId: '',
                goodsDetail: {},
                curInfo: {},
                canRequest: false,
                showListHotelName: getStorage('showListHotelName') || 'T',

            };
        },
        components: {
            price,
            layerSku,
            swiperBox
        },
        computed: {
            componentBgColor() {
                return `background:${this.finalDatas.componentBgColor};`
            },
            itemWidth() {
                return (167 * (document.documentElement.clientWidth / 375))
            },

            titFontSize() {

                var titFontSize = `font-size:${this.finalDatas.titFontSize};`
                if (this.finalDatas.titColor) {
                    titFontSize += `color:${this.finalDatas.titColor};`
                }

                return titFontSize
            },
            priceColor() {
                return `color:${this.finalDatas.priceColor}`
            },
            priceSize() {
                return `font-size:${this.finalDatas.priceFontSize}`
            },
            imgStyle() {
                if (this.finalDatas.borderType == 'circular') {
                    if (this.finalDatas.layout != 'card') {
                        return 'border-bottom-left-radius:0.213333rem;border-bottom-right-radius:0.213333rem;'
                    } else {
                        return ''
                    }
                } else {
                    return ''
                }

            },
            goodsStyle() {
                var style = ''
                console.log(this.finalDatas)

                if (this.finalDatas.borderType == 'circular') {
                    style += 'border-radius:0.213333rem;'
                }
                if (this.finalDatas.goodsStyle == 'shadow') {
                    style += `box-shadow:0px 6px 12px 0px rgba(74, 112, 196, 0.1);`
                } else {
                    if (this.finalDatas.borderColor != 'transparent') {
                        style += `border:2px solid ${this.finalDatas.borderColor};`
                    }
                }
                if (this.finalDatas.backgroundColor) {
                    style += `background:${this.finalDatas.backgroundColor};`
                }
                return style
            },
            labBg() {
                return `background:${this.finalDatas.bgcolor};`
            },
            labColor() {
                return `color:${this.finalDatas.color};`
            },
            thumbSuffix() {
                var thumbSuffix = "";
                if (this.isSquarePic == 'T') {
                    thumbSuffix =
                        "?imageView2/1/w/690/h/690/format/webp&x-oss-process=image/resize,m_fill,w_694,h_694";
                } else {
                    if (this.finalDatas.layout == "pic") {
                        thumbSuffix =
                            "?imageView2/1/w/690/h/460/format/webp&x-oss-process=image/resize,m_fill,w_694,h_460";
                    } else {
                        thumbSuffix =
                            "?imageView2/1/w/336/h/224/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224";
                    }
                }

                return thumbSuffix;
            },
        },

        methods: {

            isShowSku(goods) {
                var item = goods;
                item.shopGoodsConfig = goods.goodsConfig;
                if (this.goodsId != item.id) {
                    this.curInfo = {
                        currentStock: item.stock,
                        currentPrice: item.price,
                        currentCredit: item.credit,
                    };
                }
                this.goodsId = item.id;
                this.goodsDetail = item;
                this.$refs.layerSku.isShowSku();
            },
            update(val) {
                this.code = val
                this.shopGoodsTemplate()
            },
            goGoodsList() {
                if (this.datas.moreLink) {
                    if (this.datas.moreLink.indexOf('goodsListAll') != -1) {
                        sessionStorage.setItem("list", JSON.stringify(this.datas));
                    }
                    window.location.href = this.datas.moreLink
                } else {
                    if (this.templateId) {
                        this.$router.push({
                            path: "/typeList"
                        });
                    } else {
                        sessionStorage.setItem("list", JSON.stringify(this.datas));
                        this.$router.push({
                            name: "goodsListAll",
                            path: "/goodsListAll"

                        });
                    }

                }

            },
            shopGoodsTemplate() {
                this.finalDatas = JSON.parse(JSON.stringify(this.datas));

                var goodIds = [] //商城产品
                var goodsCodes = [] //门票产品
                var productCodes = [] //组合产品
                var promiseAll = []
                var hotelCodes = []
                if (this.finalDatas.typeList && this.finalDatas.typeList.length > 0) {
                    this.finalDatas.items = []
                    this.finalDatas.typeList.forEach(item => {
                        let typeOpt = {
                            hotelGroupCode: config.hotelGroupCode,
                            hotelCode: config.hotelCode,
                            equipment: "desktop",
                            channel: config.channel,
                            appid: config.appid,
                            orderCondition: "listOrder",
                            orderDirection: "desc",
                            firstResult: 0,
                            pageSize: 999
                        };
                        if (this.typeId != "") {
                            typeOpt.typeId = item.typeId;
                        }else if (item.parentTypeId != '') {
                            typeOpt.parentTypeId = item.parentTypeId;
                        }
                        if(config.hotelCode){
                            typeOpt.belongHotelCode = config.hotelCode;
                        }
                        if (this.user.memberId) {
                            this.getCurrentCard();
                            var chuzhiIndex = getStorage("cardIndex") || 0;
                            typeOpt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                        }
                        promiseAll.push(api.listGoods(typeOpt))
                    })
                    Promise.all(promiseAll).then(res => {
                        var noStockGoods = []
                        res.forEach((goodsList, i) => {
                            if (goodsList.result == 1) {
                                goodsList.retVal.datas.forEach((item) => {
                                    item.sourceType == 'mall'

                                    if (item.extraInfo && item.extraInfo != '') {
                                        var extraInfo = JSON.parse(item.extraInfo)
                                        extraInfo.discountList.forEach(discount => {
                                            if (extraInfo.activityType == 'fullReduction') {
                                                if (extraInfo.discountType == 'quota') {
                                                    discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                                                }
                                                if (extraInfo.discountType == 'number') {
                                                    discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                                                }
                                                if (extraInfo.discountType == 'circulate') {
                                                    discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                                                }
                                            }
                                            if (extraInfo.activityType == 'fullDiscount') {
                                                discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                                            }
                                            if (extraInfo.activityType == 'fullDelivery') {
                                                if (extraInfo.discountType == 'coupons') {
                                                    var couponsArr = []
                                                    extraInfo.couponsArr.forEach(item => {
                                                        couponsArr.push(item.descript)
                                                    })
                                                    discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                                                }
                                            }

                                        })
                                        item.extraInfo = extraInfo

                                    }
                                    if (item.vrType == 'retail') {
                                        item.stock = 999
                                    }
                                    if (item.stock <= 0) {
                                        item.isHalt = 'T'
                                    }
                                    this.finalDatas.items.push(item)
                                })

                            }
                        })
                        this.finalDatas.items.forEach(item => {
                            if (item.isHalt == 'T') {
                                noStockGoods.push(item)
                            }
                        })

                        for (var i = 0; i < this.finalDatas.items.length; i++) {
                            if (this.finalDatas.items[i].isHalt == 'T') {
                                this.finalDatas.items.splice(i, 1)
                                i--
                            }
                        }
                        this.finalDatas.items = this.finalDatas.items.concat(noStockGoods)
                        this.canRequest = true
                    })

                    return
                }
                if (this.finalDatas.goodIds && this.finalDatas.goodIds.length > 0) {
                    goodIds = this.finalDatas.goodIds.join(',')
                    var goodsList = []
                    var noStockGoods = []
                    var mallOpt = {
                        goodsIds: goodIds,
                        hotelGroupCode: config.hotelGroupCode,
                        channel: config.channel
                    }
                    if (this.user && this.user.memberId) {
                        this.getCurrentCard();
                        var chuzhiIndex = getStorage("cardIndex") || 0;
                        mallOpt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                    }
                    if (getStorage('levelCode')) {
                        mallOpt.cardCode = getStorage('levelCode')
                    }
                    promiseAll.push(api.shopGoodsTemplate(mallOpt))
                }

                this.finalDatas.items.forEach(item => {
                    if (!item.credit) {
                        item.credit = 0
                    }
                    item.pictureArr = []
                    try {
                        if (item.pictureList) {
                            item.pictureArr = item.pictureList.split(';');
                        }
                    } catch (error) {

                    }


                    if (item.sourceType == 'hotel' && item.price) {
                        item.price = Math.round(item.price)
                        hotelCodes.push({
                            type: 'room',
                            code: item.id
                        }) 
                    }
                    if (item.sourceType == 'ticket') {
                        var goodsCodeArr = item.id.split('_')
                        if (goodsCodeArr && goodsCodeArr.length > 0) {
                            var goodsCode = ""
                            if (goodsCodeArr.length == 1) {
                                goodsCode = goodsCodeArr[0]
                            } else {
                                goodsCode = goodsCodeArr[goodsCodeArr.length - 2]
                            }


                            goodsCodes.push(goodsCode)
                        }
                    }
                    if (item.sourceType == 'combination') {
                        productCodes.push(item.productCode)
                    }
                })
                if (goodsCodes.length > 0) {
                    var obj = {
                        hotelGroupCode: config.hotelGroupCode,
                        clientChannel: "WECHAT",
                        goodsCodes: goodsCodes,
                        occDate: moment().format("YYYY-MM-DD")
                    }
                    if (this.user && this.user.memberId) {
                        this.getCurrentCard();
                        var chuzhiIndex = getStorage("cardIndex") || 0;
                        obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                        obj.cardType = this.user.cardListDto[chuzhiIndex].cardType
                    }
                    promiseAll.push(api.listProductByGoodsCode(obj))

                }
                if (productCodes.length > 0) {
                    var obj = {
                        hotelGroupCode: config.hotelGroupCode,
                        productCodes: productCodes.join(','),
                    }
                    if (this.user && this.user.memberId) {
                        this.getCurrentCard();
                        var chuzhiIndex = getStorage("cardIndex") || 0;
                        obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                        obj.cardType = this.user.cardListDto[chuzhiIndex].cardType
                    }

                    promiseAll.push(api.queryPackDailyDetailForHomePage(obj))
                }
                if(hotelCodes.length>0){
                    var obj={
                       hotelGroupCode: config.hotelGroupCode,
                       hotelCode: config.hotelCode,
                       channel:'WECHAT',
                       appid: config.appid,
                       productCodes:hotelCodes
                    }
                     this.user = getStorage("user");
                    if (this.user && this.user.memberId) {
                        this.getCurrentCard();
                        var chuzhiIndex = getStorage("cardIndex") || 0;
                        obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
                        obj.cardType = this.user.cardListDto[chuzhiIndex].cardType
                    }
                    let wxuser = getStorage('wxuser')||{};
                    if (wxuser && wxuser.openid) {
                        obj.openid = wxuser.openid
                    }

                    promiseAll.push(api.listProductsMultiType(obj))
                }
                Promise.all(promiseAll).then(res => {

                    var index = 0
                    var noStockGoods = []
                    var goodsList = []
                    var ticketList = []
                    var combinationList = []
                    var hotelList = []
                    if (goodIds.length > 0) {
                        goodsList = res[index].retVal
                        index++
                    }

                    if (goodsCodes.length > 0) {
                        if (res[index].result == 1) {
                            ticketList = res[index].retVal.resultInfo
                        }
                        index++

                    }
                    if (productCodes.length > 0) {
                        if (res[index].result == 1) {
                            combinationList = res[index].retVal

                        }
                        index++

                    }
                    if(hotelCodes.length>0){
                         if (res[index].result == 0) {
                            hotelList = res[index].retVal
                         }
                      
                    }
                    this.finalDatas.items.forEach(item => {
                        if (item.sourceType == 'mall') {
                            item.isHalt = 'T'
                            if (goodsList.length == 0) {
                                item.onUnSale = '0'
                            }
                            for (const i in goodsList) {
                                if (item.id == goodsList[i].id) {
                                    var secondTitle = item.secondTitle
                                    item = Object.assign(item, goodsList[i]);
                                    item.pictureArr = goodsList[i].picList
                                    item.isHalt = 'F'
                                    item.onUnSale = '1'
                                    if (secondTitle) {
                                        item.secondTitle = secondTitle
                                    }
                                    if (item.extraInfo && item.extraInfo != '') {
                                        var extraInfo = JSON.parse(item.extraInfo)
                                        extraInfo.discountList.forEach(discount => {
                                            if (extraInfo.activityType == 'fullReduction') {
                                                if (extraInfo.discountType == 'quota') {
                                                    discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                                                }
                                                if (extraInfo.discountType == 'number') {
                                                    discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                                                }
                                                if (extraInfo.discountType == 'circulate') {
                                                    discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                                                }
                                            }
                                            if (extraInfo.activityType == 'fullDiscount') {
                                                discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                                            }
                                            if (extraInfo.activityType == 'fullDelivery') {
                                                if (extraInfo.discountType == 'coupons') {
                                                    var couponsArr = []
                                                    extraInfo.couponsArr.forEach(item => {
                                                        couponsArr.push(item.descript)
                                                    })
                                                    discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                                                }
                                            }

                                        })
                                        item.extraInfo = extraInfo

                                    }
                                    if (goodsList[i].vrType == 'retail') {
                                        item.stock = 999
                                    }
                                    if (item.stock <= 0) {
                                        item.isHalt = 'T'
                                    }
                                    break;
                                } else {
                                    item.onUnSale = '0'
                                }
                            }
                        }
                        if (item.sourceType == 'ticket') {
                            ticketList.forEach(goods => {
                                var productCodeArr = item.id.split('_')
                                if (productCodeArr && productCodeArr.length > 0) {
                                    var productCode = productCodeArr[productCodeArr.length - 2]
                                    if (productCodeArr.length == 1) {
                                        productCode = productCodeArr[0]
                                    }
                                    if (productCode == goods.goodsCode) {
                                        if(goods.ticketSaleMode=='point'){
                                            item.credit = goods.realPoint
                                            item.price = 0
                                        }else{
                                            item.price = goods.realPrice
                                        }
                                        
                                        item.name = goods.name
                                        if (goods.pictureUrl) {
                                            var pictures =  goods.pictureUrl.replace(/;/g, ',').split(',').filter((item) => item)
                                            item.pictureArr = pictures

                                            item.logo = pictures[0]
                                        }

                                        // item.url = `/wechat/?/#/ticketInfo?productCode=${goods.productCode}`
                                        // item.stock = goods.saleNum
                                        // if (item.stock <= 0) {
                                        //   item.isHalt = 'T'

                                        // }
                                    }

                                }
                            })
                        }
                        if (item.sourceType == 'combination') {
                            combinationList.forEach(goods => {
                                if (item.productCode == goods.productCode) {
                                    item.price = goods.realPrice
                                    if (goods.pictureList && goods.pictureList.length > 0) {
                                        item.pictureArr = goods.pictureList
                                        item.logo = goods.pictureList[0]
                                    }
                                    // item.stock = goods.saleNum
                                    // if (item.stock <= 0) {
                                    //   item.isHalt = 'T'
                                    // }
                                }
                            })

                        }
                        if (item.sourceType == 'hotel') {
                            hotelList.forEach(goods => {
                                if (item.id == goods.goodsId) {
                                    if(goods.attributes.roomAvailable!='false'){
                                        goods.roomAvailable = goods.attributes.roomAvailable
                                    }
                                     if(goods.attributes.scoreMin){
                                        goods.scoreMin = goods.attributes.scoreMin
                                    }
                                    item.price = goods.price
                                    item.name = goods.goodsName
                                    if(goods.roomAvailable!='false'){
                                        item.credit = goods.scoreMin
                                        if(goods.scoreMin>0&&goods.price==-1){
                                            item.price = 0
                                        }
                                    }
                                    if (goods.pictureUrl) {
                                        var pictures =  goods.logo.replace(/;/g, ',').split(',').filter((item) => item)
                                        item.pictureArr = pictures

                                        item.logo = pictures[0]
                                    }
                                }
                            })
                        }
                    })
                    this.finalDatas.items.forEach(item => {
                        if (item.isHalt == 'T' && item.onUnSale != '0') {
                            noStockGoods.push(item)
                        }
                    })

                    for (var i = 0; i < this.finalDatas.items.length; i++) {
                        if (this.finalDatas.items[i].isHalt == 'T' || this.finalDatas.items[i].onUnSale == '0') {
                            this.finalDatas.items.splice(i, 1)
                            i--
                        }
                    }
                    this.finalDatas.items = this.finalDatas.items.concat(noStockGoods)
                    this.canRequest = true
                })
            },

            goGoods(item) {
                if (!item.url) {
                    if (item.vrType == 'sass') {
                        this.$router.push({
                            path: "/sassGoodsDetail",
                            query: {
                                id: item.id
                            },
                        });
                    } else {
                        this.$gc.track({
                            behaviorType: 7,
                            goodsId: item.id,
                            goodsName: item.name
                        });
                        this.$router.push({
                            path: "/goodsDetail",
                            query: {
                                id: item.id
                            },
                        });
                    }
                } else {
                    if (item.sourceType == 'ticket') {
                        if (this.isLogin()) {
                            var distributor = ''
                            if (this.$route.query.distributorId) {
                                distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}&distributorId=${this.$route.query.distributorId}&distributorOpenId=${this.$route.query.distributorOpenIdDis}`
                            } else if (this.$route.query.distributorOpenIdDis) {
                                distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}`
                            }
                            window.location.href = `${window.location.origin}${item.url}${distributor}`;
                        }
                    } else {
                        var distributor = ''
                        if (this.$route.query.distributorId) {
                            distributor = `&distributorId=${this.$route.query.distributorId}&distributorOpenId=${this.$route.query.distributorOpenIdDis}`
                        } else if (this.$route.query.distributorOpenIdDis) {
                            distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}`
                        }
                        window.location.href = `${window.location.origin}${item.url}${distributor}`;
                    }

                }
            },

        },
        created() {
            config = getStorage('config');
        },
        mounted() {
            this.shopGoodsTemplate()

        },
    };
</script>

<style lang="less" scoped>
    @import url("~@/styles/base.less");
    @import url("~@/styles/mixin.less");

    .goods-list {
        padding: 0.4rem 0;

        .goods-list-header {
            display: flex;
            margin-bottom: 0.48rem;
            position: relative;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.533333rem;

            .goods-list-title {

                font-size: 18px;
                color: #1d1e2c;
            }

            .more {
                font-size: 12px;
                color: #666666;
                display: flex;
                position: relative;
                align-items: center;
                // position: absolute;
                // bottom: 0;
                // right: 0.533333rem;

                i {
                    font-size: 12px;
                    color: #666666;
                }
            }
        }

        .goods-list-box {
            padding: 0 0.4rem;
            margin-top: -0.266667rem;

            &.grid {
                .goods-list-container {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                }
            }

            &.waterfall {
                .box {
                    .img-box {
                        height: auto;

                        img {
                            width: 100%;
                            height: auto;
                            display: block;
                        }
                    }

                    .goods-content {
                        .goods-name {
                            max-height: 1.066667rem;
                            height: auto;
                        }

                        .goods-desc {
                            height: auto;
                            max-height: 0.586667rem;
                        }
                    }
                }

            }

            &.pic {
                .box {
                    width: 100%;

                    .img-box {
                        height: 6.133333rem;

                        &.img-box-square {
                            height: 9.2rem;
                        }

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .goods-content {
                        .goods-name {
                            font-size: 18px;
                            color: #333333;
                            line-height: 0.666667rem;
                            height: 1.333333rem;
                        }

                        .price {
                            justify-content: flex-start;
                        }
                    }
                }
            }

            &.mult {
                width: 100%;
                white-space: nowrap;
                display: flex;
                overflow-y: hidden;
                overflow-x: scroll;

                .goods-list-container {
                    .box {
                        width: 4rem;
                        margin-right: 0.266667rem;

                        .img-box {
                            height: 2.666667rem;

                            &.img-box-square {
                                height: 4rem;
                            }
                        }
                    }
                }
            }

            &.card {
                .box {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    .img-box {
                        width: 4.346667rem;
                        height: 2.8978rem;

                        &.img-box-square {
                            height: 2.8978rem;
                            width: 2.8978rem;
                        }

                        .bg {
                            display: none;
                        }

                        .bg2 {
                            display: block;
                        }
                    }
                }

                .goods-content {
                    flex: 1;
                    text-align: left;

                    .goods-name {
                        font-size: 14px;
                        color: #333333;
                        -webkit-line-clamp: 2;
                        line-height: 0.533333rem;
                        height: 1.066666rem;
                    }

                    .price {
                        justify-content: flex-start;
                    }
                }
            }

            .box {
                width: 4.453333rem;
                background: #fff;
                margin-top: 0.266667rem;
                display: inline-block;
                box-sizing: border-box;
                position: relative;
                overflow: hidden;

                .swiper-wrapper {
                    position: relative;
                    width: 100%;
                    height: 230px;

                    .swiper-slide {
                        width: 100%;
                        height: 100%;
                        transform: translate3d(0, 0, 0);

                        .poster {
                            width: 100%;
                            height: 100%;
                            position: absolute;

                            .play-img {
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                width: 1.333333rem;
                                height: 1.333333rem;
                                transform: translate(-50%, -50%);
                            }
                        }

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .img-box {
                    width: 100%;
                    overflow: hidden;
                    height: 2.96rem;
                    position: relative;
                    box-sizing: border-box;

                    img {
                        display: block;
                    }

                    &.img-box-square {
                        height: 4.453333rem;
                    }

                    .hotelName {
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        width: 86%;
                        margin-left: -43%;
                        height: 0.47988rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        b {
                            position: absolute;
                            width: 100%;
                            height: 0.47988rem;
                            z-index: 2;
                            font-size: 10px;
                            color: #fff;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            line-height: 0.47988rem;
                            text-align: center;
                            padding: 0 0.266667rem;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            z-index: 1;
                            left: 50%;
                            margin-left: -41.5%;
                            width: 83%;
                            background: @color-theme;
                            opacity: 0.6;
                            height: 0.47988rem;
                            box-sizing: border-box;
                            border-radius: 0.21328rem 0.21328rem 0 0;
                            transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
                        }
                    }

                    .img {
                        width: 100%;
                        height: 100%;
                    }

                    .bg {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        left: 0;
                        top: 0;
                    }

                    .label {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 0.64rem;
                        font-size: 12px;
                        color: #ffffff;
                        padding: 0 0.266667rem;
                        line-height: 0.64rem;
                        text-align: center;
                        z-index: 2;

                        .labelBg {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: -1;
                            width: 100%;
                            height: 100%;
                            background: #df4747;
                            opacity: 0.6;
                            border-radius: 0 0.213333rem 0.213333rem 0px;
                        }
                    }
                }

                .goods-content {
                    padding: 0 0.266667rem 0.293333rem 0.266667rem;

                    .goods-name {
                        margin-top: 0.133333rem;
                        font-size: 14px;
                        line-height: 0.533333rem;
                        height: 1.066667rem;
                        color: #333333;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }

                    .goods-desc {
                        line-height: 0.586667rem;
                        height: 0.586667rem;
                        font-size: 12px;
                        color: #999999;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }

                    .goods-discount {
                        height: 19px;
                        overflow: hidden;

                        .goods-discount-item {
                            border-radius: 2px;
                            color: @color-price;
                            font-size: 10px;
                            margin-top: 5px;
                            border: 1px solid @color-price;
                            display: inline-block;
                            padding: 0 2px;
                            line-height: 14px;
                            height: 14px;
                            white-space: nowrap;
                            margin-right: 0.133333rem;

                        }
                    }

                    .price-box {
                        display: flex;
                        color: #e55141;
                        padding-right: 0.6rem;
                        justify-content: flex-start;

                        .price {
                            font-size: 12px;
                            display: inline-block;
                            align-items: center;
                            margin-top: 0.133333rem;
                            font-family: @price-font-family;

                            .cur-price {
                                display: inline-block;
                                font-size: 0;

                            }

                            .qi {
                                display: inline-block;
                            }

                            span {
                                display: inline-block;

                                i {
                                    display: inline-block;
                                    text-decoration: none;
                                    font-size: 12px;

                                }

                                b {
                                    display: inline-block;
                                    text-decoration: none;
                                    font-size: 25px;
                                }
                            }

                            span.proposedPrice {
                                line-height: 16px;
                                text-decoration: line-through;
                                color: #999999;
                                font-size: 12px;
                                font-family: PingFangSC-Regular;
                            }

                            .credit {
                                display: inline-block;
                                font-style: normal;
                                font-size: 10px;
                                line-height: 16px;

                                em,
                                b {
                                    display: inline-block;
                                }

                                span {
                                    font-size: 14px;
                                    display: inline-block;
                                }
                            }

                            .free {
                                b {
                                    font-size: 18px;
                                }
                            }
                        }
                    }

                    .add-shopCar {
                        position: absolute;
                        right: 0.266667rem;
                        text-align: center;
                        font-size: 24px;
                        border-radius: 50%;
                        color: #fff;
                        height: 0.533333rem;
                        width: 0.533333rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-shadow: 0px 4px 8px 0px rgba(74, 112, 196, 0.1);
                        background: #fff;

                        i {
                            color: @color-theme;
                            font-size: 8px;
                        }
                    }
                }

                .no-stock {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(255, 255, 255, 0.8);
                    z-index: 8;

                    img {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        width: 2.213333rem;
                        height: 1.253333rem;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }

    }

    /deep/ .vue-waterfall {
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/polymerization/GoodsList.vue